<template>
  <div
    @click="callAction"
    :class="element.cssClasses"
    :style="Object.assign(element.styles, {'leading-relaxed': sub})"
  >
    <div
      :class="{'tracking-wide font-medium': sub && !element.cssClasses, 'tracking-widest font-medium': !sub && !element.cssClasses}"
      v-if="element.type === 'text'"
    >{{ element.value }}</div>
    <div v-else-if="element.type === 'icon'">
      <icon
        :name="element.value"
        :size="
          element.iconSettings && element.iconSettings.size
            ? element.iconSettings.size
            : '1em'
        "
        :settings="element.iconSettings ? element.iconSettings : {}"
      />
    </div>
    <div class="relative" v-else-if="element.type === 'dropdown'">
      <button @click="toggleDropdown" class="button-transparent button-no-spacing">
        <icon name="More" />
      </button>
      <drop-down @close="toggleDropdown(false)" v-if="dropdownVisible" class="leading-relaxed">
        <div v-for="(sub, index) in element.elements" :key="index" class="cursor-pointer">
          <WdHeaderElement sub :element="sub" @close="toggleDropdown" />
        </div>
      </drop-down>
    </div>
  </div>
</template>

<script>
import { HeaderElement } from "@/modules/header/viewmodels/HeaderElement";

import { isString } from "util";
import { isFunction } from "util";

const DropDown = require("@/modules/core/components/DropDown.vue").default;

export default {
  name: "WdHeaderElement",
  data() {
    return {
      dropdownVisible: false
    };
  },
  props: {
    element: {
      type: HeaderElement,
      default: new HeaderElement()
    },
    sub: {
      default: false,
      type: Boolean
    }
  },
  components: {
    DropDown
  },
  methods: {
    callAction() {
      if (
        this.element.action !== null &&
        this.element.action !== undefined &&
        isFunction(this.element.action)
      ) {
        this.element.action();
      }
    },
    toggleDropdown(bool) {
      this.dropdownVisible =
        typeof bool === "boolean" ? bool : !this.dropdownVisible;
    }
  },
  computed: {},
  created() {}
};
</script>
